export default __webpack_public_path__ + "static/glass-2192cbbf0d7b7e95500982439273aa56.png";